import React from 'react';

import Card from '../Card/Card';
import DonutBase from '../DonutBase/DonutBase';

export const DonutWidget = ({
  data,
  dataKey,
  centerTitle,
  centerCount,
  className,
  isLoading,
  size,
  legendPosition = 'bottom',
  legendBackground,
  legendTitle = '',
  innerRadius,
  startAngle,
  legendFormatter,
  endAngle,
  hideLegend,
  ...props
}) => (
  <Card
    className={`DonutWidget ${
      className ? className : ''
    } legend-position-${legendPosition}`}
    isLoading={isLoading}
    {...props}>
    <DonutBase
      size={size}
      data={data}
      dataKey={dataKey}
      centerTitle={centerTitle}
      hideLegend={hideLegend}
      centerCount={centerCount}
      legendTitle={legendTitle}
      innerRadius={innerRadius}
      startAngle={startAngle}
      endAngle={endAngle}
      legendBackground={legendBackground}
      legendFormatter={legendFormatter}
    />
  </Card>
);

export default DonutWidget;
